import React from 'react';

function AssessmentsListEmptyState() {
  return (
    <div className="assessments-list__empty-state">
      <div>
        Once assessments are started they will be listed on this page.
      </div>
    </div>
  );
}

export default AssessmentsListEmptyState;



// WEBPACK FOOTER //
// ./src/components/features/dashboard/AssessmentsListEmptyState.js